(function () {
    'use strict';

    var keycloakConfig = {
        //those values could be changed at runtime
        url: 'https://keycloak.eismoinfo.lt',
        realm: 'EIS'
    };
    var gazetteerUrl = 'https://arcgis.vialietuva.lt/gazetteer/search';
    var runtimeVarFragment = '_RUNTIME_VAR_';
    if (keycloakConfig.url.indexOf(runtimeVarFragment) !== -1) {
        keycloakConfig.url = 'https://keycloak-test.eismoinfo.lt';
    }
    if (keycloakConfig.realm.indexOf(runtimeVarFragment) !== -1) {
        keycloakConfig.realm = 'EIS_TEST';
    }
    if (gazetteerUrl.indexOf(runtimeVarFragment) !== -1) {
        gazetteerUrl = 'https://arcgis-test.vialietuva.lt/gazetteer/search';
    }
    angular.module('core')
        .constant('serviceBase', '/road-monitoring-services')
        .constant('arcgisBase', 'https://eismoinfo.lt/arcgis/rest/services')
        .constant('gazetteerUrl', gazetteerUrl)
        .constant('columnsCookieName', 'RMWVisibleColumns')
        .constant('keycloakConfig', {
            url: keycloakConfig.url,
            realm: keycloakConfig.realm,
            clientId: 'road-monitoring-services',
            responseMode: 'query',
            accessTokenMinValidity: 300
        });
})();
